import { useQuery } from 'react-query';
import { queryConsultationQuestions } from './useConsultationQuestions.query';
import {
  UseConsultationQuestionsOptions,
  UseConsultationQuestionsResponse,
} from './useConsultationQuestions.types';

export const CONSULTATION_QUESTIONS_QUERY_KEY = 'CONSULTATION_QUESTIONS';

export const useConsultationQuestions = (
  consultationId: number,
  options?: UseConsultationQuestionsOptions
) => {
  return useQuery<UseConsultationQuestionsResponse[], Error>(
    CONSULTATION_QUESTIONS_QUERY_KEY,
    () => queryConsultationQuestions(consultationId),
    {
      retry: true,
      refetchOnWindowFocus: true,
      ...options,
    }
  );
};
